<template>
    <div class="spot">
        <p>{{ value }}</p>
    </div>
</template>

<script>
export default {
    name: "Spot",
    props: {
        value: Number
    }
}
</script>

<style lang="scss" scpoed>
@import '../../../../../assets/scss/variables.scss';
div.spot {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid $c14;
    background: $c2;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
        color: $c14;
        font-size: $p4;
        font-weight: $weight_bold;
        text-align: center;
        margin-bottom: 0;
        line-height: 28px;
    }
}
</style>